export default "/assets/x-blue.svg";